exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Notifications\n   ========================================================================== */\n.notifications {\n  position: absolute;\n  top: 100px;\n  right: 20px;\n  z-index: 90;\n  overflow-x: hidden;\n  padding: 0 10px 15px 10px; }\n\n/* ==========================================================================\n   Notification\n   ========================================================================== */\n.notification {\n  display: flex;\n  align-items: center;\n  min-height: 50px;\n  max-width: 390px;\n  padding-right: 10px;\n  border-radius: 3px;\n  background-color: #fff;\n  box-shadow: 0 6px 17px 0 rgba(0, 0, 0, 0.16), 0 8px 14px 0 rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n  transform: translateX(0);\n  transition: transform 0.3s ease; }\n  .notification:not(:first-child) {\n    margin-top: 20px; }\n  .notification--animation-enter, .notification--animation-exit {\n    transform: translateX(calc(100% + 20px)); }\n\n.notification__icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  flex-shrink: 0;\n  width: 50px;\n  color: #fff; }\n\n.notification__close-icon {\n  color: #ddd;\n  cursor: pointer; }\n\n.notification__content {\n  flex: auto;\n  padding: 15px 20px;\n  word-break: break-all; }\n\n/* States\n   ========================================================================== */\n.notification--success .notification__icon {\n  background-color: #6acb4c; }\n\n.notification--error .notification__icon {\n  background-color: #f54545; }\n\n.notification--warning .notification__icon {\n  background-color: #eca03e; }\n\n.notification--instruction .notification__icon {\n  background-color: #25b8d2; }\n\n.notification--info .notification__icon {\n  background-color: #834ba2; }\n\n.notification--hint .notification__icon {\n  background-color: #c2c2c2; }\n\n@media (max-width: 767px) {\n  .notifications {\n    top: 60px;\n    left: 0;\n    right: 0;\n    overflow-x: visible;\n    padding: 0; }\n  .notification {\n    transform: translateY(0);\n    transition: transform 0.7s ease;\n    max-width: 100%; }\n    .notification--animation {\n      /* We dont know the vertical position of the\n        current notification, because there might be a few of them stacked.\n        We animate to (-50vh - the_notification_size),\n        and the animation duration is changed to 0.7.\n\n        TODO: Refactor if better solution is found. */ }\n      .notification--animation-enter {\n        transform: translateY(-100vh); }\n      .notification--animation-exit {\n        transform: translateY(calc(-50vh - 100%)); }\n    .notification .notification__icon {\n      width: 40px; }\n    .notification .notification__content {\n      padding: 10px 15px; }\n  .notification__icon {\n    width: 40px; } }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};